import ProfilePage from '@/views/restricted/management/profile/ProfilePage.vue'
import DistributorLayout from '@/layouts/DistributorLayout.vue'
import ProfileCreateCollaboratorPage
  from '@/views/restricted/management/profile/collaborator/ProfileCreateCollaboratorPage.vue'
import ProfileEditCollaboratorPage
  from '@/views/restricted/management/profile/collaborator/ProfileEditCollaboratorPage.vue'

export default [
  {
    path: '/profile',
    name: 'Profile',
    menuSelected: 'profile',
    component: ProfilePage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout
    }
  },
  {
    path: '/profile/create-collaborator/new',
    name: 'ProfileCreateCollaborator',
    component: ProfileCreateCollaboratorPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout
    }
  },
  {
    path: '/profile/edit-collaborator/:collaboratorId',
    name: 'ProfileEditeCollaborator',
    component: ProfileEditCollaboratorPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout
    }
  }
]
